// extracted by mini-css-extract-plugin
module.exports = {"NotificationHandler":"NotificationHandler_NotificationHandler__3Xqqw"};